import { IGetProdutosServicosByIdRequisicaoCompraDropDownUseCase } from "../../../presentation/useCases/read/get_produtos_servicos_by_id_requisicao_compra_drop_down_use_case";
import { RequisicaoProdutoServicoDropDown } from "../../models/requisicao_produto_servico_dropdown";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetProdutosServicosByIdRequisicaoCompraDropDownUseCase
 */

export class GetProdutosServicosByIdRequisicaoCompraDropDownUseCase
  implements IGetProdutosServicosByIdRequisicaoCompraDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getProdutosServicosByIdRequisicaoCompraDropDown(
    idRequisicaoCompra: number,
  ): Promise<RequisicaoProdutoServicoDropDown[]> {
    return await this.repository.getProdutosServicosByIdRequisicaoCompraDropDown(
      idRequisicaoCompra,
    );
  }
}
